import { createContext, useContext, useEffect, useState } from "react";
import { effectivePrice } from "@/lib/format";

const CartContext = createContext(null);
const KEY = "fasmart_cart_v1";

export function CartProvider({ children }) {
  // Lazy init dari localStorage — hindari race dengan write-effect saat mount
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) {
        return JSON.parse(raw).map((i) => ({
          ...i,
          key: i.key || `${i.product_id}::`,
          needs_design: i.needs_design || false,
        }));
      }
    } catch {}
    return [];
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, variant_name = "", variant_price = null) => {
    const key = `${product.id}::${variant_name}`;
    const price = variant_price ?? effectivePrice(product);
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + qty } : i));
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          variant_name,
          needs_design: !!product.needs_design,
          category: product.category,
          name: product.name,
          price,
          qty,
          image_url: product.image_url,
          unit: product.unit,
        },
      ];
    });
  };

  const setQty = (key, qty) => {
    if (qty <= 0) return remove(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };

  const remove = (key) => setItems((p) => p.filter((i) => i.key !== key));
  const clear = () => setItems([]);
  const count = items.reduce((a, b) => a + b.qty, 0);
  const subtotal = items.reduce((a, b) => a + b.qty * b.price, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
